var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.0682C5.53076 14.4922 6.23165 14.75 7 14.75C7.76835 14.75 8.46924 14.4922 9 14.0682M1.38073 11.8863C1.06452 11.8863 0.887905 11.3896 1.07918 11.1136C1.52302 10.4732 1.95141 9.53386 1.95141 8.40274L1.96972 6.76374C1.96972 3.71859 4.22185 1.25 7 1.25C9.81907 1.25 12.1044 3.75495 12.1044 6.84496L12.0861 8.40274C12.0861 9.54163 12.4997 10.4861 12.9255 11.1267C13.1094 11.4034 12.9323 11.8863 12.62 11.8863H1.38073Z",
    stroke: "#1B4DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconbell);
export default __webpack_public_path__ + "static/media/Iconbell.86502dff489dc1d60ea12a1eb673ede7.svg";
export { ForwardRef as ReactComponent };